import React, { useEffect } from "react";
import Router from "./Router";
import "./components/@vuexy/rippleButton/RippleButton";

import "react-perfect-scrollbar/dist/css/styles.css";
import "prismjs/themes/prism-tomorrow.css";
import { useDispatch, useSelector } from "react-redux";
import { setUtmSource } from "./redux/actions/NEWDASHBOARD/utmSource";
import { regenerateTokenApi } from "./services/newServices";
import storageService from "./services/storageServices";
import { routes } from "./component_route/Index";
import { getPanelAccesses } from "./redux/actions/NEWDASHBOARD/panelAccesses";
import { getConfig } from "./whitelabel_config";

const App = (props) => {
  const dispatch = useDispatch();
  const { selectedHotel } = useSelector((state) => state.hotels);

  const queryParams = new URLSearchParams(window.location.search);
  const utm_source = queryParams.get("utm_source");
  const isLoginPage = window.location.href.includes(routes.login);
  const token = storageService.get("token");

  const whitelabelConfig = getConfig();

  useEffect(() => {
    dispatch(setUtmSource(utm_source));
  }, [utm_source]);

  useEffect(() => {
    //if (isLoginPage) return;
    if (!token) return;
    const regenerateToken = async () => {
      const userAdmin = storageService.get("userAdmin");
      const regenObj = {
        regenrateToken: userAdmin?.regenrateToken,
      };
      const regenResp = await regenerateTokenApi(regenObj);
      if (regenResp?.status === 200) {
        if (regenResp?.data?.regenrateToken) {
          userAdmin.regenrateToken = regenResp.data.regenrateToken;
        }
        const token = regenResp?.data?.token;
        storageService.set("userAdmin", userAdmin);
        storageService.set("token", token);
      }
    };
    regenerateToken();
  }, [isLoginPage]);

  useEffect(() => {
    if (selectedHotel?.id) {
      dispatch(getPanelAccesses({ hotelId: selectedHotel.id }));
    }
  }, [selectedHotel?.id]);

  const updateFavicon = (iconUrl) => {
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = iconUrl;
    document.getElementsByTagName("head")[0].appendChild(link);
  };

  useEffect(() => {
    updateFavicon(whitelabelConfig.logo);
  }, [whitelabelConfig.logo]);

  // useEffect(() => {
  //   window.addEventListener("focus", () => {
  //     window.location.reload();
  //   });
  //   return () =>
  //     window.removeEventListener("focus", () => console.log("removed"));
  // }, []);
  return <Router />;
};

export default App;
